module.exports = __webpack_public_path__ + "static/media/react.776fd826.png";